"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var CheckableTag = _antd.Tag.CheckableTag;
var Checkable = function Checkable() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CheckableTag, {
    checked: true
  }, "Error"), /*#__PURE__*/_react.default.createElement(CheckableTag, {
    checked: false
  }, "Error"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Checkable, null),
  tokens: ['colorPrimary', 'colorPrimaryHover', 'colorPrimaryActive'],
  key: 'multiTags'
};
var _default = exports.default = componentDemo;